import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles/index';
import classNames from 'classnames';
import { FormControlLabel, Avatar, Button, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography, Radio, Divider } from 'material-ui';
import { connect } from 'react-redux';
import * as quickPanelActions from 'main/quickPanel/store/actions';
import * as authActions from 'auth/store/actions';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { ListItem } from 'material-ui';
import { NavLink } from 'react-router-dom';
import { setUserData } from 'auth/store/actions/user.actions';
import { setDefaultSettings } from 'store/actions/fuse';


const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    seperator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider
    }
});

class MainToolbar extends Component {
    state = {
        userMenu: null,
        shown: false,
        isActivePanel: 'LEFT'
    };

    userMenuClick = event => {
        this.setState({ userMenu: event.currentTarget });
    };

    userMenuClose = () => {
        this.setState({ userMenu: null });
    };

    handleRadioChange = (e) => {
        // alert(window.panel)

        console.log('default settings', this.props.auth);
        this.setState({
            isActivePanel: e.target.value
        });
        if (e.target.value == 'LEFT') {
            this.setState({
                shown: false
            });
            this.props.setDefaultSettings({ layout: { navbar: 'left' } });


        } else {
            this.setState({
                shown: true
            });
            this.props.setDefaultSettings({ layout: { navbar: 'none' } });
        }


    }

    render() {
        const { classes, toggleQuickPanel, user, logout, navigation } = this.props;
        const { userMenu } = this.state;
        console.log('navigation from props', this.props.navigation);
        console.log('settings from props', this.props.auth);


        return (
            <div className={classNames(classes.root, "navbar flex flex-row")}>

                <div className="flex flex-1">
                    {/* <FuseShortcuts/> */}
                    {/* Second top nav */}
                    <React.Fragment>
                        <div class="navbar flex flex-1 ">


                            {/* new navbar */}
                            {
                                this.state.shown
                                    ?

                                    <div class="navbar">
                                        <ul>
                                            {/* Add Logo for here */}
                                            {navigation.map((parent) => {
                                                return (
                                                    <li>
                                                        <Icon className="{classes.buttonIcon} profile-text-color nav-btn-position">{parent.icon ? parent.icon : ''}</Icon>
                                                        <a >{parent.title}</a>

                                                        {parent.children ?
                                                            <ul className="nav-ul-list">
                                                                {parent.children.map((child) => {
                                                                    return (
                                                                        // <li class="nav-margin "><a href="#">{child.title}</a>
                                                                        <li className="listsize">
                                                                            <ListItem
                                                                                button
                                                                                component={NavLink}
                                                                                to={child.url ? child.url : ''}
                                                                            >

                                                                                {child.title}
                                                                                {child.children ?
                                                                                    <ul>
                                                                                        {child.children.map((childsChild) => {
                                                                                            return (
                                                                                                <li className="listsize">
                                                                                                    <ListItem
                                                                                                        button
                                                                                                        component={NavLink}
                                                                                                        to={childsChild.url}
                                                                                                    >
                                                                                                        {childsChild.title}
                                                                                                    </ListItem>
                                                                                                </li>
                                                                                                // <li class="nav-margin "><a href="#">{childsChild.title}</a></li>
                                                                                            )
                                                                                        })}
                                                                                    </ul>
                                                                                    :
                                                                                    null
                                                                                }
                                                                            </ListItem>
                                                                        </li>
                                                                    )
                                                                    /* return(
                                                                        <li class="nav-margin "><a href="#">{child.title}</a></li>
                                                                    ) */
                                                                })}


                                                            </ul>
                                                            :
                                                            null
                                                        }
                                                    </li>
                                                );
                                            })}
                                        </ul>

                                    </div>


                                    : null

                            }
                        </div>
                    </React.Fragment>
                </div>

                <div className="flex">

                    <Button
                        className="h-64"
                        aria-owns={userMenu ? 'user-menu' : null}
                        aria-haspopup="true"
                        onClick={this.userMenuClick}
                    >
                        {user.data ? (
                            <React.Fragment>
                                <Avatar className="" alt="Guest" src={user.data.avatar} />

                                <div className="hidden md:flex flex-col ml-12 items-start">
                                    <Typography component="span" className="normal-case font-500 flex">
                                        {(user.data.name) ? user.data.name : "" + ' ' + (user.data.lastname) ? user.data.lastname : ""}
                                    </Typography>
                                    <Typography className="text-11 capitalize profile-text-color" color="">
                                        {user.role}
                                    </Typography>
                                </div>
                            </React.Fragment>
                        ) : (
                                <React.Fragment>
                                    <Avatar className="" alt="Guest" src="assets/images/avatars/profile.jpg" />
                                    <div className="hidden md:flex flex-col ml-12 items-start">
                                        <Typography component="span" className="normal-case font-500 flex">
                                            Guest
                                    </Typography>
                                        <Typography className="text-11 capitalize profile-text-color" color="">
                                            {user.role}
                                        </Typography>
                                    </div>
                                </React.Fragment>
                            )}

                        <Icon className="text-16 ml-12 hidden sm:flex profile-text-color" variant="action">keyboard_arrow_down</Icon>
                    </Button>
                    <Menu
                        id="user-menu"
                        anchorEl={userMenu}
                        open={Boolean(userMenu)}
                        onClose={this.userMenuClose}
                        classes={{
                            paper: 'mt-48'
                        }}
                    >
                        {user.role === 'guest' ? (
                            <React.Fragment>
                                <MenuItem component={Link} to="/login"
                                >
                                    <ListItemIcon>
                                        <Icon>lock</Icon>
                                    </ListItemIcon>
                                    <ListItemText className="pl-0" primary="Login" />
                                </MenuItem>

                            </React.Fragment>
                        ) : (
                                <React.Fragment>
                                    {/* <MenuItem component={Link} to="/pages/profile" onClick={this.userMenuClose}>
                                        <ListItemIcon>
                                            <Icon>account_circle</Icon>
                                        </ListItemIcon>
                                        <ListItemText className="pl-0" primary="My Profile" />
                                    </MenuItem>
                                    <MenuItem component={Link} to="/apps/mail" onClick={this.userMenuClose}>
                                        <ListItemIcon>
                                            <Icon>mail</Icon>
                                        </ListItemIcon>
                                        <ListItemText className="pl-0" primary="Inbox" />
                                    </MenuItem> */}

                                    <MenuItem
                                        onClick={() => {

                                        }}
                                    >
                                        <ListItemIcon>
                                            <FormControlLabel
                                                //className="md:mb-24 sm:mb-0"
                                                control={
                                                    <Radio
                                                        checked="true"
                                                        onChange={this.handleRadioChange}
                                                        value="TOP"
                                                        checked={this.state.isActivePanel === 'TOP'}

                                                        name="radioBaseUnit"
                                                        aria-label="A"
                                                        color="secondary"
                                                    />
                                                }
                                                label="Top Navigation"
                                            />



                                        </ListItemIcon>
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() => {

                                        }}
                                    >
                                        <ListItemIcon>
                                            <FormControlLabel
                                                //className="md:mb-24 sm:mb-0"
                                                control={
                                                    <Radio
                                                        checked=""
                                                        onChange={this.handleRadioChange}
                                                        value="LEFT"
                                                        checked={this.state.isActivePanel === 'LEFT'}
                                                        name="radioBaseUnit"
                                                        aria-label="A"
                                                        color="secondary"
                                                    />

                                                }
                                                label="Left Navigation"
                                            />

                                        </ListItemIcon>
                                    </MenuItem>

                                    <Divider className="md:mt-16 sm:mt-8" />
                                    <MenuItem
                                        onClick={() => {
                                            logout();
                                            this.userMenuClose();
                                        }}
                                    >
                                        <ListItemIcon>
                                            <Icon>exit_to_app</Icon>
                                        </ListItemIcon>
                                        <ListItemText className="pl-0" primary="Logout" />
                                    </MenuItem>
                                </React.Fragment>
                            )}
                    </Menu>

                    <div className={classes.seperator} />

                    {/* <IconButton className="w-64 h-64">
                        <Icon>search</Icon>
                    </IconButton> */}

                    {/* <div className={classes.seperator}/> */}

                    {/* <IconButton className="w-64 h-64" onClick={() => toggleQuickPanel(true)}>
                        <Icon>format_list_bulleted</Icon>
                    </IconButton> */}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleQuickPanel: quickPanelActions.toggleQuickPanel,
        logout: authActions.logoutUser,
        setDefaultSettings: setDefaultSettings
    }, dispatch);
}


function mapStateToProps({ auth, fuse }) {
    return {
        user: auth.user,
        navigation: fuse.navigation,
        auth: auth
    }
}


export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js